import { SvgIcon, SvgIconProps } from '@mui/material';

// Shares SignatureCheckboxIcon's exact box geometry (viewBox + rect) so the
// contract checkbox looks identical whether checked or unchecked — only the
// checkmark differs.
export const SignatureCheckboxUncheckedIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <rect
      x="2.5"
      y="2.5"
      width="15"
      height="15"
      rx="2.5"
      stroke="currentColor"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
